import React from "react";
import { Reveal, Overline } from "./Reveal";
import { ILLO } from "../lib/assets";

const CHAPTERS = [
  { no: "01", title: "Design", body: "We translate how you live into precise drawings, layouts and 3D visuals — before a single wall moves." },
  { no: "02", title: "Install", body: "Our own execution teams build it — modular joinery, civil work and finishing — to the exact spec you approved." },
  { no: "03", title: "Deliver", body: "We hand over a finished, move-in-ready home. One team, one accountability, zero vendor juggling." },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 bg-warm" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-start">
          <div>
            <Reveal><Overline>Why DIDIT</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-navy mt-5 leading-[1.03]">
                You dream it.<br />
                <span className="text-terracotta">We did it.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-ink/75 text-lg leading-relaxed mt-8 max-w-md">
                Most interior journeys break because they&apos;re stitched together from designers, contractors and vendors who never talk. DIDIT owns the whole line — so you coordinate with one team, not ten.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="grid grid-cols-3 gap-6 mt-12 pt-10 border-t border-navy/10">
                {[["End to end", "Design → handover, one line"], ["One team", "Single point of accountability"], ["Move-in ready", "Finished, not half-done"]].map(([n, l]) => (
                  <div key={l}>
                    <p className="font-display text-xl md:text-2xl font-light text-navy leading-tight">{n}</p>
                    <p className="text-xs text-ink/60 mt-2 tracking-wide">{l}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="space-y-2">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="group flex gap-6 py-7 border-b border-navy/10" data-testid={`about-chapter-${c.no}`}>
                  <span className="font-display text-sm text-terracotta pt-2 tracking-widest">{c.no}</span>
                  <div>
                    <h3 className="font-display text-3xl md:text-4xl font-light text-navy group-hover:translate-x-1 transition-transform duration-300">{c.title}</h3>
                    <p className="text-ink/70 mt-3 leading-relaxed max-w-md">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <div className="pt-8 flex items-center gap-5">
                <img src={ILLO.reader} alt="At home with DIDIT" className="w-28 h-28 object-contain mix-blend-multiply" />
                <p className="font-display text-xl text-navy/70 font-light leading-snug max-w-[220px]">
                  Until it feels like the home you always pictured.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
